export type Level = "easy" | "medium" | "hard";

export interface Paddle {
  x: number;
  y: number;
  radius: number;
}

export interface Puck {
  x: number;
  y: number;
  vx: number;
  vy: number;
  radius: number;
}

export interface AirHockeyGame {
  p1: Paddle;
  p2: Paddle;
  puck: Puck;
  score: [number, number];
  winner: number | null;
  message: string;
  slowdown: number;
  level: Level;
}

export const CANVAS_W = 700;
export const CANVAS_H = 400;
export const GOAL_SIZE = 60;
export const WALL_PADDING = 14;
export const PADDLE_RADIUS = 20;
export const PUCK_RADIUS = 10;
export const PADDLE_SPEED = 280;
export const MAX_SCORE = 7;

export const LEVEL_SPEEDS: Record<Level, { puckSpeed: number; maxSpeed: number; kickSpeed: number }> = {
  easy:   { puckSpeed: 200, maxSpeed: 400, kickSpeed: 140 },
  medium: { puckSpeed: 300, maxSpeed: 550, kickSpeed: 200 },
  hard:   { puckSpeed: 420, maxSpeed: 750, kickSpeed: 280 },
};
